import script from "./CreatePermission.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreatePermission.vue?vue&type=script&setup=true&lang=ts"

import "./CreatePermission.vue?vue&type=style&index=0&id=d55f1266&lang=scss"

const __exports__ = script;

export default __exports__